<template>
    <modal width="35" :show-modal="showModal" @close-modal="$emit('close-modal')">
      <div class="delete-modal">
        <div class="flex justify-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="67" height="67" viewBox="0 0 47 47" fill="none">
                <g clip-path="url(#clip0_2930_39997)">
                <path d="M46.3001 23.1501C46.3001 35.9356 35.9356 46.3001 23.1501 46.3001C10.3646 46.3001 0 35.9356 0 23.1501C0 10.3646 10.3646 0 23.1501 0C35.9356 0 46.3001 10.3646 46.3001 23.1501Z" fill="#EA3C53" fill-opacity="0.1"/>
                <path fill-rule="evenodd" clip-rule="evenodd" d="M23 34C16.9249 34 12 29.0751 12 23C12 16.9249 16.9249 12 23 12C29.0751 12 34 16.9249 34 23C34 29.0751 29.0751 34 23 34ZM23 32C27.9706 32 32 27.9706 32 23C32 18.0294 27.9706 14 23 14C18.0294 14 14 18.0294 14 23C14 27.9706 18.0294 32 23 32ZM19.7071 27.7071L23 24.4142L26.2929 27.7071L27.7071 26.2929L24.4142 23L27.7071 19.7071L26.2929 18.2929L23 21.5858L19.7071 18.2929L18.2929 19.7071L21.5858 23L18.2929 26.2929L19.7071 27.7071Z" fill="#EA3C53"/>
                </g>
                <defs>
                <clipPath id="clip0_2930_39997">
                <rect width="46.3" height="46.3" fill="white"/>
                </clipPath>
                </defs>
                </svg>
        </div>
  
        <div class="my-6">
          <div class="text-red-500">Your wallet balance is insufficent for this booking</div>

              <div class="pt-3">Kindly select an alternative payment.</div>
        </div>

        <div>
          <el-select
          filterable
          placeholder="Select Payment method"
        >
          <el-option
            v-for="method in ['Charge Card', 'Charge Wallet', 'Cash Payment', 'Pay On Delivery']"
            :key="method"
            :label="method"
            :value="method"
          >
          </el-option>
        </el-select>
        </div>
          <div>
            <base-button @click="closeModal()" text="Close" />
          </div>
      </div>
    </modal>
  </template>
  
  <script>
  export default {
    props: {
      showModal: {
        type: Boolean,
        required: true,
        default: false,
      },
      endRoute: {type: String}
    },
    data(){
      return {
        showDeclineReasonModal: false
      }
    },

    methods: {
      closeModal() {
        this.showDeclineReasonModal = true
        this.$emit("close-modal");
        this.$router.push('/active-bookings')
        this.$store.dispatch('saveLatestNewBookinTabNum', 1)
        this.$store.dispatch('saveResetNewBookingState')
      },
    }
  };
  </script>
  
  <style scoped>
  .delete-modal {
    text-align: center;
  }
  </style>
  